export default [
  {
    name: 'couponList',
    path: 'couponList',
    component: () => import(/* webpackChunkName: "couponList" */ './index.vue')
  },
  {
    name: 'couponListDetail',
    path: 'couponList/detail',
    component: () =>
      import(/* webpackChunkName: "couponList" */ './CouponForm.vue')
  },
  {
    name: 'couponApplied',
    path: '/couponList/couponApplied',
    component: () =>
      import(/* webpackChunkName: "couponList" */ './CouponApplied.vue')
  },
  {
    name: 'couponUsed',
    path: '/couponList/couponUsed',
    component: () =>
      import(/* webpackChunkName: "couponList" */ './CouponUsed.vue')
  },
  {
    name: 'couponStatistics',
    path: '/couponList/couponStatistics',
    component: () =>
      import(/* webpackChunkName: "campaignStatistics" */ './statistics.vue')
  }
]
